export const INPUTS = [
  {
    param: "name_vch",
    label: "List Name",
    placeholder: "Sample List",
    isRequired: true,
    classNames: "col-12 col-md-6",
  },
];

export const TAG_INPUTS = [
  {
    label: "Email List",
    param: "email_list_txt",
    type: "email",
    key: "email",
    placeholder: "Add new email: sample@email.com",
  },
  {
    label: "SMS List",
    param: "text_list_txt",
    type: "phone",
    key: "sms",
    placeholder: "Add new phone number: 1112223333",
  },
  {
    label: "Voice List",
    param: "voice_list_txt",
    type: "phone",
    key: "voice",
    placeholder: "Add new phone number: 1112223333",
  },
  // Voice not currently supported
].filter(({ key }) => key !== "voice");
